// Recovered compiled webpack factory 39684. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "useRouterBFCache", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(12115);
  function a(e, t) {
    let [r, a] = (0, n.useState)(() => ({ tree: e, stateKey: t, next: null }));
    if (r.tree === e) return r;
    let o = { tree: e, stateKey: t, next: null },
      i = 1,
      s = r,
      l = o;
    for (; null !== s && i < 1; ) {
      if (s.stateKey === t) {
        l.next = s.next;
        break;
      }
      {
        i++;
        let e = { tree: s.tree, stateKey: s.stateKey, next: null };
        ((l.next = e), (l = e));
      }
      s = s.next;
    }
    return (a(o), o);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
